export default __webpack_public_path__ + "static/media/Matches.8a9f532f.png";